import { format, formatDistanceToNow, parseISO, isValid } from 'date-fns'

export const formatters = {
  currency: (amount: number, currency = 'USD') =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(amount),

  number: (value: number, options?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat('en-US', {
      notation: 'compact',
      maximumFractionDigits: 1,
      ...options
    }).format(value),

  percentage: (value: number, decimals = 1) => `${(value * 100).toFixed(decimals)}%`,

  date: (date: string | Date, formatStr = 'MMM dd, yyyy') => {
    const dateObj = typeof date === 'string' ? parseISO(date) : date
    return isValid(dateObj) ? format(dateObj, formatStr) : 'Invalid date'
  },

  relativeTime: (date: string | Date) => {
    const dateObj = typeof date === 'string' ? parseISO(date) : date
    return isValid(dateObj) ? formatDistanceToNow(dateObj, { addSuffix: true }) : 'Invalid date'
  }
}

export const calculations = {
  roi: (revenue: number, spend: number) => spend === 0 ? 0 : ((revenue - spend) / spend) * 100,
  ctr: (clicks: number, impressions: number) => impressions === 0 ? 0 : (clicks / impressions) * 100,
  cpm: (spend: number, impressions: number) => impressions === 0 ? 0 : (spend / impressions) * 1000
}